var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attach-box"},[_c('ul',[_c('li',[_c('i',{staticClass:"ico-info"}),_c('div',[_c('p',{staticClass:"text_warn"},[_vm._v("상업적 이용 금지")]),_c('p',{staticClass:"text_warn"},[_vm._v("어떠한 승인 없이 동영상, 파일을 무단 도용, 복제할 시 법적 처벌을 받을 수 있습니다.")])])])])])
}]

export { render, staticRenderFns }